import { render } from "./HighlightRichText.vue?vue&type=template&id=b15ccbae"
import script from "./HighlightRichText.vue?vue&type=script&lang=js"
export * from "./HighlightRichText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__